export const FILE_MANAGEMENT_CONSTANTS = {
  WELCOME_TO_FILE_MANAGEMENT: "Welcome to File Management",
  DOWNLOAD: "Download",
  DELETE: "Delete",
  NEW_FOLDER: "New Folder",
  LIST_OF_FILES: "List of Files ",
  CANCEL: "CANCEL",
  CONTINUE: "Continue",
  VALID_FILE_SIZE:
    "Please make sure that the file being uploaded is not password protected. Such files will be removed by the system after upload. The file size limit is less than 2 GB.",
  UPLOAD_FILE: "Upload File",
  DELETE_SELECTED: "Delete Selected",
  DONE: "DONE",
  OK: "OK",
  YES: "YES",
  DELETE_ACTIVE_ISO_DESCRIPTION:
    "Please stop or complete the course instance before deleting the file.",
  COURSE_ACTIVE_DESCRIPTION:
    "is currently in use by an active course instance.",
  DELETE_ANYWAY: "Delete Anyway",
  DELETE_DESCRIPTION: "Are you sure you want to delete the following",
  SEARCH_THE_NAME: "Search the name",
  BACK_TO_FILE_MANAGEMENT: "Back to File Management",
  UPLOAD_FILES: "Upload File",
  FILE_ALREADY_EXISTS: "File name already exists. Please use a different file name.",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE: "Are you sure you want to delete?",
  DELETE_FILES: "Delete Files",
  DELETE_FILE: "Delete File",
  FILE_DOWNLOAD_STARTED:
    "File download started. Please wait for it to complete",
  FOLDER_ALREADY_EXIST: "Folder already exists. Choose a different name.",
  FILE_SIZE_EXCEEDS_LIMIT:
    "File Size Is Exceeding 2GB. Please Upload A File Smaller Than 2GB.",
  FOLDER_NAME_CANNOT_BE_EMPTY: "Folder name can not be empty.",
    SEARCH_ON_PRESS_ENTER: "Search on press of enter",
  FILE_NAME_EXCEEDS_LIMIT:
    "File name is Exceeding 100 Characters. Please upload a file with a shorter name.",
};
